<template>
    <div class="match-live-container">
        <h2 class="live-title">Saya ada siaran langsung gratis</h2>

        <ul v-if="channels.length || isLoading" class="channel-list">
            <li v-for="(channel, index) in channels" class="channel-item" :key="channel.cname">
                <div class="channel-info" @click="handleChannelClick(channel)">
                    <img class="icon-living" src="../assets/icons/icon-living.png" />
                    <span class="channel-name">{{ channel.cname }}</span>

                    <img class="icon-play" src="../assets/icons/icon-left.png" />
                </div>

                <div class="channel-likes" @click="handleChannelLike(index)">
                    <img v-if="channel.like" class="icon-like" src="../assets/icons/icon-tread.png" />
                    <img v-else class="icon-like" src="../assets/icons/icon-like.png" />

                    <span class="likes-count">{{ channel.likes }}</span>
                </div>
            </li>
        </ul>

        <div v-if="!isLoading && !channels.length" class="data-empty">
            Siaran langsung streaming gratis sedang dipersiapkan untuk Anda simak sebelum pertandingan dimulai!
        </div>

        <button class="add-channel-btn" @click="popupVisible = true">
            <img class="icon-plus" src="../assets/icons/icon-add.png" />
            <span class="add-channel-text">Saya ada siaran langsung gratis</span>
        </button>

        <AppLoading :loading="isLoading" />

        <AppLivePopup :visible="popupVisible" @close="popupVisible = false" @submit="handleSubmit" />
    </div>
</template>

<script>
import axios from 'axios'
import AppLoading from './AppLoading.vue'
import AppLivePopup from './AppLivePopup.vue'
import { convertToFiveMillion } from '../util/common'

export default {
    components: {
        AppLoading,
        AppLivePopup
    },

    props: {
        matchId: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            isLoading: false,
            popupVisible: false,
            likeNum: [621, 257, 106, 78, 0],
            channels: [],
        }
    },

    computed: {
        matchLiveFormation() {
            return this.$store.state.matchDetailStore.matchLiveFormation
        }
    },

    mounted() {
        const result = (this.matchLiveFormation || []).map((item, i) => ({ ...item, like: false, likes: this.likeNum[i] }))

        this.channels = result
    },

    methods: {
        handleChannelClick(channel) {
            window.open(channel.url, '_blank')
        },

        handleChannelLike(order) {
            const channel = this.channels[order]

            channel.like = !channel.like
            channel.like ? channel.likes++ : channel.likes--
        },

        async handleSubmit(channel) {
            this.isLoading = true

            try {
                const cid = convertToFiveMillion(this.matchId)
                const params = {
                    match_id: cid,
                    url: encodeURIComponent(channel)
                }

                await axios({
                    url:'https://match.allfootballapp.com/app/live/userAdd',
                    method:'get',
                    params
                })

                this.popupVisible = false
                this.$toast('hasil baik');
            } catch (error) {
                this.$toast('Pengiriman Gagal');
                console.log(error)
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>

<style lang="less" scoped>
* {
    box-sizing: border-box;
}

.match-live-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F5F5F5;
    padding: 0 1.5rem 1.8125rem;

    .live-title {
        width: 100%;
        padding: 1.1875rem;
        text-align: center;
        font-size: 0.8125rem;
        font-weight: 500;
        color: #8C969F;
        font-family: SF UI Display;
        background: inherit;
    }

    .channel-list {
        // height: 23.9375rem;
        // height: 18.9375rem;
        flex-grow: 1;
        margin-bottom: 0.625rem;
        overflow-y: auto;

        .channel-item {
            display: flex;
            align-items: center;

            &:not(:last-child) {
                margin-bottom: 0.625rem;
            }

            .channel-info {
                display: flex;
                align-items: center;
                width: 16.8125rem;
                height: 3.125rem;
                padding: 1rem 1.1875rem;
                border-radius: 1.5625rem;
                background: #FFFFFF;

                .icon-living {
                    margin-right: 0.375rem;
                    width: 1.125rem;
                    height: 1.125rem;
                }

                .channel-name {
                    max-width: 12rem;
                    font-weight: bold;
                    font-size: 0.875rem;
                    color: #16B13A;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .icon-play {
                    margin-left: auto;
                    width: 0.375rem;
                    height: 0.625rem;
                }
            }

            .channel-likes {
                margin-left: .1875rem;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 3.125rem;
                height: 3.125rem;
                border-radius: 50%;
                background: #FFFFFF;

                .icon-like {
                    width: 0.9375rem;
                    height: 0.9375rem;
                }

                .likes-count {
                    margin-top: 0.1875rem;
                    font-weight: 400;
                    font-size: 0.625rem;
                    color: #8C969F;
                }
            }
        }
    }

    .data-empty {
        flex-grow: 1;
        padding: 1.875rem 0.9375rem;
        line-height: 1.25rem;
        text-align: center;
        font-size: 0.875rem;
        color: #8C969F;
    }

    .add-channel-btn {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20.4375rem;
        height: 3.125rem;
        border: none;
        border-radius: 1.5625rem;
        background: #FFFFFF;

        .icon-plus {
            margin-right: 0.375rem;
            width: 0.75rem;
            height: 0.75rem;
        }

        .add-channel-text {
            font-weight: bold;
            font-size: 0.875rem;
            color: #8C969F;
        }
    }
}
</style>



// WEBPACK FOOTER //
// matchLive.vue?71af17d1